import "./App.css";

import { Route, Routes, useLocation } from "react-router-dom";
import Homepage from "./pages/Homepage";
import SoloPractitioners from "./pages/SoloPractitioners";
import LegalTeams from "./pages/LegalTeams";
import LawFirms from "./pages/LawFirms";
import LawStudies from "./pages/LawStudies";
import JudgesClerks from "./pages/JudgesClerks";
import Careers from "./pages/Careers";
import InvestorRelations from "./pages/InvestorRelations";
import AboutUs from "./pages/AboutUs";
import Teams from "./pages/Teams";
import ContactUs from "./pages/ContactUs";
import JoinWaitlist from "./pages/JoinWaitlist";
import Collaborator from "./pages/Collaborator";
import Schedule from "./pages/Schedule";
import JobDetails from "./pages/JobDetails";

import BlogComponent from "./components/BlogListing/BlogComponent";
import SingleBlog from "./components/BlogListing/SingleBlog";
import Practitioners from "./pages/Practitioners";
import Judges_LawClerks from "./pages/Judges_LawClerks";
import Academia from "./pages/Academia";
import LawStudents from "./pages/LawStudents";
import LawSchools from "./pages/LawSchools";
import Scholars from "./pages/Scholars";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { useMediaQuery } from "react-responsive";
import ProductOverview from "./pages/ProductOverview";
import SecurityAndTrust from "./pages/SecurityAndTrust";
import TermsOfUse from "./pages/Terms_Of_Use";
import CookiePolicy from "./pages/Cookie_Policy";
import NewsandInsight from "./pages/NewsandInsight";
import NewsPage from "./pages/NewsPage";

function App() {
  const location = useLocation();
  const isMobile = useMediaQuery({ maxWidth: "767.5px" });

  return (
    <Routes>
      <Route
        path="/"
        element={<Homepage page={"homepage"} isMobile={isMobile} />}
      />
      <Route path="/term-of-use" element={<TermsOfUse isMobile={isMobile} />} />
      <Route
        path="/cookie-policy"
        element={<CookiePolicy isMobile={isMobile} />}
      />
      <Route
        path="/region/:name"
        element={<Homepage page={location?.pathname?.slice(8)} />}
      />

      {/* container done */}
      <Route
        path="/solo-practitioners"
        element={<SoloPractitioners isMobile={isMobile} />}
      />

      <Route
        path="/practitioners"
        element={<Practitioners isMobile={isMobile} />}
      />
      {/* container done */}
      <Route path="/law-firms" element={<LawFirms isMobile={isMobile} />} />
      {/* container done */}

      <Route
        path="/in-house-legal-teams"
        element={<LegalTeams isMobile={isMobile} />}
      />
      <Route path="/law-studies" element={<LawStudies isMobile={isMobile} />} />
      <Route
        path="/judges-and-court-clerks"
        element={<JudgesClerks isMobile={isMobile} />}
      />

      {/* container done */}
      <Route
        path="/judges-and-law-clerks"
        element={<Judges_LawClerks isMobile={isMobile} />}
      />
      <Route path="/academia" element={<Academia isMobile={isMobile} />} />

      {/* container done */}
      <Route
        path="/law-students"
        element={<LawStudents isMobile={isMobile} />}
      />
      {/* container done */}
      <Route path="/law-schools" element={<LawSchools isMobile={isMobile} />} />

      {/* container done */}
      <Route path="/scholars" element={<Scholars isMobile={isMobile} />} />
      <Route
        path="/privacy-policy"
        element={<PrivacyPolicy isMobile={isMobile} />}
      />
      <Route
        path="/product-overview"
        element={<ProductOverview isMobile={isMobile} />}
      />
      <Route path="/careers" element={<Careers isMobile={isMobile} />} />
      <Route
        path="/investors"
        element={<InvestorRelations isMobile={isMobile} />}
      />
      <Route path="/about" element={<AboutUs isMobile={isMobile} />} />
      {/* <Route path="/team" element={<Teams isMobile={isMobile} />} /> */}
      <Route path="/contact" element={<ContactUs isMobile={isMobile} />} />
      <Route
        path="/waiting-list"
        element={<JoinWaitlist isMobile={isMobile} />}
      />
      <Route
        path="/collaborator"
        element={<Collaborator isMobile={isMobile} />}
      />
      <Route
        path="/schedule-a-demo"
        element={<Schedule isMobile={isMobile} />}
      />
      <Route path="/job-details" element={<JobDetails isMobile={isMobile} />} />
      <Route path="/blogs" element={<BlogComponent isMobile={isMobile} />} />
      <Route path="/blogs/:slug" element={<SingleBlog isMobile={isMobile} />} />
      <Route
        path="/security-trust"
        element={<SecurityAndTrust isMobile={isMobile} />}
      />
      <Route path="/news" element={<NewsandInsight />} />
      <Route path="/news/:slug" element={<NewsPage isMobile={isMobile} />} />
    </Routes>
  );
}

export default App;
